module.exports = __webpack_public_path__ + "media/images/flags/nf-7a4f3d1b34fa49f5a098666d39b3ba44.svg";